export default function PHP_connect() {
  return (
    <div>
      <h1>PHP_connect</h1>
    </div>
  );
}
